module.exports = __webpack_public_path__ + "media/images/red-9426545bec33cf9b5ffbc773391cdc0c.png";